import { Company } from "../models/Company";
import { baseUrl, fetchAndParse, headers } from "./utils"

export const retrieveCompany = (id: string) => {
    const url = new URL(`/companies/${id}/`, baseUrl);
    return fetchAndParse<Company>(url.toString(), { method: "GET", headers })
}